@import "../../../globalStyles/commons";

:host {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: var(--z-index-modal);
}

:host([open]) {
  display: block;
}

.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;

  .modal-overlay {
    position: absolute;
    content: '';
    background: var(--overlay);
    width: 100%;
    height: 100%;
  }

  .modal--wrapper {
    width: 100vw;
    height: 100vh;
    overflow: auto;
    padding: 10% 0 var(--spacing-09) 0;
    z-index: 1;
  }
}

.modal {
  margin: auto;
  width: 100%;
  background: var(--layer-01);

  .modal__content {
    padding: 0 0 var(--spacing-09);
  }

  .modal-header {
    display: flex;

    .modal-heading-section {
      padding: 1rem 0 0 1rem;
      flex: 1;
      margin-bottom: 1rem;

      .modal-heading {
        margin-bottom: 0;
      }
    }

  }

  .action-container {
    display: flex;
    flex-direction: row-reverse;

    .close-icon {
      --goat-button-height: 3rem;
      --goat-button-border-radius: 0;
    }
  }

  /*
   * Loader styles
   */
  &.show-loader {
    position: relative;
  }

  .modal__loading {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;

    .modal__loading-background {
      position: absolute;
      content: '';
      background: var(--overlay);
      width: 100%;
      height: 100%;
    }
  }
}

/**
  * SIZES
  */

:host([size="xs"]) {
  @include for-phone-only {
    .modal {
      width: 100%;
    }
  }

  @include for-tablet-portrait-up {
    .modal {
      width: 48%;
    }
  }

  @include for-tablet-landscape-up {
    .modal {
      width: 32%;
    }
  }

  @include for-desktop-up {
    .modal {
      width: 24%;
    }
  }
}

:host([size="sm"]) {
  @include for-phone-only {
    .modal {
      width: 100%;
    }
  }

  @include for-tablet-portrait-up {
    .modal {
      width: 60%;
    }
  }

  @include for-tablet-landscape-up {
    .modal {
      width: 42%;
    }
  }

  @include for-desktop-up {
    .modal {
      width: 36%;
    }
  }
}


:host([size="md"]) {
  @include for-phone-only {
    .modal {
      width: 100%;
    }
  }

  @include for-tablet-portrait-up {
    .modal {
      width: 84%;
    }
  }

  @include for-tablet-landscape-up {
    .modal {
      width: 60%;
    }
  }

  @include for-desktop-up {
    .modal {
      width: 48%;
    }
  }
}

:host([size="lg"]) {
  @include for-phone-only {
    .modal {
      width: 100%;
    }
  }

  @include for-tablet-portrait-up {
    .modal {
      width: 96%;
    }
  }

  @include for-tablet-landscape-up {
    .modal {
      width: 84%;
    }
  }

  @include for-desktop-up {
    .modal {
      width: 72%;
    }
  }
}
